module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1502-e66cf58e0c5e2f8fdd07d7876088ba8d.png";